import { BookableItemType, OrderStatus, reportingPrisma as prisma } from "client";
import { REPORT_TYPE } from "../attendeeReport/index";
export const getEventsDataCount = async (
  entityId: string,
  type?: REPORT_TYPE
) => {
  let matchStage: any;
  if (type == REPORT_TYPE.ORGANIZATION) {
    matchStage = [
      {
        $lookup: {
          from: "Organization",
          localField: "event.organizationIds",
          foreignField: "_id",
          as: "organization",
        },
      },
      { $unwind: "$organization" },
      { $match: { "organization._id": { $oid: entityId } } },
    ];
  } else matchStage = [{ $match: { _id: { $oid: entityId } } }];
  const stages = [
    {
      $lookup: {
        from: "Event",
        localField: "_id",
        foreignField: "whiteLabelId",
        as: "event",
      },
    },
    { $unwind: "$event" },
    ...matchStage,
    {
      $lookup: {
        from: "Ticket",
        localField: "event._id",
        foreignField: "eventId",
        as: "ticket",
      },
    },

    {
      $group: {
        _id: null,
        total: { $sum: 1 },
        active: {
          $sum: {
            $cond: {
              if: { $eq: ["$event.published", true] },
              then: 1,
              else: 0,
            },
          },
        },
        Draft: {
          $sum: {
            $cond: {
              if: { $eq: ["$event.published", false] },
              then: 1,
              else: 0,
            },
          },
        },
        ended: {
          $sum: {
            $cond: {
              if: {
                // Only mark as ended if endDate exists and is before now
                $and: [
                  { $ifNull: ["$event.endDate", false] },
                  { $lt: ["$event.endDate", "$$NOW"] },
                ],
              },
              then: 1,
              else: 0,
            },
          },
        } as any,
      },
    },
    {
      $project: {
        _id: 0,
        summary: [
          { title: "All Events", metric: "$total" },
          { title: "Active Events", metric: "$active" },
          { title: "Ended Events", metric: "$ended" },
          { title: "Draft Events", metric: "$Draft" },
        ],
      },
    },
  ];
  type EventCountResult = {
    summary: {
      title: string;
      metric: number;
    }[];
  };
  const EventCounts: any = await prisma.whiteLabel.aggregateRaw({
    pipeline: [...stages],
  });
  if (EventCounts && EventCounts?.length && EventCounts[0]?.summary) {
    const result = EventCounts[0].summary;
    return result;
  } else {
    return [
      { title: "All Events", metric: 0 },
      { title: "Active Events", metric: 0 },
      { title: "Ended Events", metric: 0 },
      { title: "Draft Events", metric: 0 },
    ];
  }
};
export const getTicketQuantitiesByOrganization = async (
  organizationId: string,
  orderStatus?: OrderStatus
) => {
  if (!!orderStatus) {
    const totalOrderCount = await prisma.orderItem.count({
      where: {
        order: {
          event: {
            organizationIds: {
              has: organizationId,
            },
          },
          status: {
            equals: orderStatus,
          },
        },
      },
    });
    return [
      {
        title: "Tickets",
        metric: totalOrderCount,
      },
    ];
  } else {
    const totalTicketQuantity = await prisma.bookableItem.aggregate({
      where: {
        type: BookableItemType.TICKET,
        ticket: {
          event: {
            organizationIds: {
              has: organizationId,
            },
          },
        },
      },
      _sum: {
        quantity: true,
      },
    });

    const totalQuantity = totalTicketQuantity._sum.quantity || 0;

    return [
      {
        title: "Tickets",
        metric: totalQuantity,
      },
    ];
  }
};
export const getTicketQuantitiesByWhiteLabel = async (
  whiteLabelId: string,
  orderStatus?: OrderStatus
) => {
  if (!!orderStatus) {
    const totalOrderCount = await prisma.orderItem.count({
      where: {
        order: {
          event: {
            whiteLabelId: whiteLabelId,
          },
          status: {
            equals: orderStatus,
          },
        },
      },
    });
    return [
      {
        title: "Tickets",
        metric: totalOrderCount,
      },
    ];
  } else {
    const totalTicketQuantity = await prisma.bookableItem.aggregate({
      where: {
        type: BookableItemType.TICKET,
        ticket: {
          event: {
            whiteLabelId: whiteLabelId,
          },
        },
      },
      _sum: {
        quantity: true,
      },
    });

    const totalQuantity = totalTicketQuantity._sum.quantity || 0;

    return [
      {
        title: "Tickets",
        metric: totalQuantity,
      },
    ];
  }
};
